import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-options-tray',
    templateUrl: './options-tray.component.html',
    styleUrls: ['./options-tray.component.scss'],
    standalone: false
})
export class OptionsTrayComponent {
  @HostBinding('class') componentClass = 'me-2 mt-4';
  @Input() expanded = true;
  @Input() nonCollapsible = false;
  @Input('displayMargin')
  set displayMargin(displayMargin: boolean) {
    this.componentClass = displayMargin ? 'me-2 mt-4' : '';
  }

  onToggleExpanded(): void {
    this.expanded = this.nonCollapsible ? this.expanded : !this.expanded;
  }
}
